<template>
  <search-body />
</template>

<script>
import SearchNetworking from "@/components/searchNetworking/SearchNetworking.vue";

export default {
  name: "NetworkSearchPage",
  components: { "search-body": SearchNetworking },
  data() {
    return {};
  },
  methods: {},
};
</script>
